import { AiFillQuestionCircle } from "react-icons/ai";
import { BsChevronBarUp } from "react-icons/bs";
import { BsChevronBarDown } from "react-icons/bs";
import { FaCog } from "react-icons/fa";

import { MdEmail } from "react-icons/md";
import { GrLinkedin } from "react-icons/gr";
import { FaGithub } from "react-icons/fa";
import { FaArtstation } from "react-icons/fa";
import { FaSteam } from "react-icons/fa";

import { IoLogoJavascript } from "react-icons/io5";
import { SiTypescript } from "react-icons/si";
import { FaPython } from "react-icons/fa";
import { SiC } from "react-icons/si";
import { SiCplusplus } from "react-icons/si";
import { FaHtml5 } from "react-icons/fa";
import { FaCss3Alt } from "react-icons/fa";

import { FaReact } from "react-icons/fa";
import { FaAngular } from "react-icons/fa";
import { FaWpforms } from "react-icons/fa";
import { FaNodeJs } from "react-icons/fa";
import { SiDotnet } from "react-icons/si";
import { FaAws } from "react-icons/fa";
import { MdScreenLockPortrait } from "react-icons/md";
import { TbApi } from "react-icons/tb";
import { FaDatabase } from "react-icons/fa";
import { BiLogoPostgresql } from "react-icons/bi";
import { SiSqlite } from "react-icons/si";

import { SiSourceengine } from "react-icons/si";
import { SiBlender } from "react-icons/si";

const designer = (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" role="img" viewBox="0 0 240 234" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M101.5,87.1c-3.2-2.8-6.9-4.9-10.9-6c-4.5-1.3-9.2-2-13.9-1.9c-2.1,0-3.9,0-5.4,0.1c-1.4,0.1-3.1,0.1-4.9,0.2
                v66.7c1.2,0,2.3,0,3.2,0.1c1,0.1,2,0.1,3,0.2c1,0.1,2.2,0.1,3.5,0.1c4.9,0.1,9.7-0.7,14.3-2.3c4.1-1.4,7.9-3.7,11-6.8
                c3.1-3.1,5.6-6.9,7.1-11.1c1.7-4.8,2.6-9.9,2.5-15c0.1-4.8-0.7-9.6-2.4-14.1C107,93.3,104.6,89.8,101.5,87.1z"/>
            <path d="M197.5,0h-155C19,0,0,19,0,42.5v149C0,215,19,234,42.5,234h155c23.5,0,42.5-19,42.5-42.5v-149
                C240,19,221,0,197.5,0z M130.8,131.3c-2,5.6-5.1,10.9-9,15.4c-3.7,4.2-8.1,7.8-13,10.7c-4.8,2.8-10,5-15.5,6.3
                c-5.3,1.3-10.8,2-16.3,2h-12c-4.2,0-8.2,0-11.8-0.1c-3.7-0.1-6.4-0.1-8.2-0.2c-0.6,0-1-0.5-1-1.6V61.4c-0.1-0.6,0.4-1.2,1.1-1.3
                c0,0,0,0,0.1,0c1.6-0.1,4-0.2,7.1-0.2c3.1-0.1,6.8-0.1,10.9-0.2c4.2-0.1,8.6-0.1,13.4-0.1c12.9,0,23.6,2.2,32,6.6
                c8,4,14.7,10.3,19.1,18.1c4.2,7.7,6.4,16.5,6.4,26.5C134.2,117.8,133.1,124.7,130.8,131.3z M199.8,154.8c-2.8,4-6.7,7.1-11.2,8.9
                c-4.9,2.1-10.9,3.2-18.1,3.2c-4.6,0-9.1-0.4-13.6-1.3c-3.4-0.6-6.7-1.7-9.7-3.2c-0.7-0.4-1.2-1.1-1.1-1.9v-17.4
                c0-0.3,0.1-0.7,0.4-0.9c0.3-0.2,0.6-0.1,0.9,0.1c3.7,2.3,7.7,3.9,11.9,4.9c3.8,1,7.8,1.5,11.8,1.5c3.8,0,6.5-0.5,8.3-1.4
                c1.6-0.7,2.7-2.4,2.7-4.2c0-1.4-0.8-2.7-2.4-4c-1.6-1.3-4.9-2.8-9.8-4.7c-5.1-1.8-9.8-4.2-14.2-7.2c-3.1-2.2-5.7-5.1-7.6-8.5
                c-1.6-3.2-2.4-6.7-2.3-10.2c0-4.3,1.2-8.4,3.4-12.1c2.5-4,6.2-7.2,10.5-9.2c4.7-2.4,10.6-3.5,17.7-3.5c4.1,0,8.3,0.3,12.4,0.9
                c2.9,0.4,5.7,1.2,8.4,2.3c0.4,0.1,0.8,0.5,1,0.9c0.1,0.4,0.2,0.8,0.2,1.2v16.3c0,0.4-0.2,0.8-0.5,1c-0.3,0.2-0.8,0.2-1.1,0
                c-3-1.6-6.2-2.7-9.6-3.4c-3.7-0.8-7.4-1.3-11.2-1.3c-2-0.1-4.1,0.2-6,0.7c-1.3,0.3-2.4,1-3.1,2c-0.5,0.8-0.8,1.8-0.8,2.7
                c0,0.9,0.4,1.8,1,2.6c0.9,1.1,2.1,2,3.4,2.7c2.3,1.2,4.7,2.3,7.1,3.3c5.4,1.8,10.6,4.3,15.4,7.3c3.3,2.1,6,4.9,7.9,8.3
                c1.6,3.2,2.4,6.7,2.3,10.3C203.7,146.3,202.4,150.9,199.8,154.8z"/>
        </g>
    </svg>
);

const painter = (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" role="img" viewBox="0 0 240 234" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M197.5,0h-155C19,0,0,19,0,42.5v149C0,215,19,234,42.5,234h155c23.5,0,42.5-19,42.5-42.5v-149
                C240,19,221,0,197.5,0z M122.1,116.4c-4,5.6-9.6,9.8-16.1,12.2c-7.2,2.6-14.9,3.9-22.5,3.8c-2.4,0-4,0-5-0.1
                c-1-0.1-2.4-0.1-4.3-0.1v31.7c0.1,0.7-0.4,1.3-1.1,1.4c-0.1,0-0.2,0-0.4,0H53c-0.8,0-1.1-0.4-1.1-1.3V61.2c0-0.8,0.3-1.1,1-1.1
                c1.7,0,3.8,0,6.1-0.1c2.4-0.1,4.9-0.1,7.6-0.2c2.7-0.1,5.6-0.1,8.7-0.2c3.1-0.1,6.1-0.1,9.1-0.1c8.2,0,15,1,20.6,3.1
                c5,1.7,9.6,4.5,13.4,8.2c3.2,3.2,5.7,7.1,7.3,11.4c1.5,4.2,2.3,8.5,2.3,13C128.1,103.8,126.1,110.9,122.1,116.4z M188.6,102.9
                c0.1,0.5-0.3,1-0.8,1.1h-15.3v34.5c0,3.6,0.6,6.3,1.9,7.8c1.2,1.6,3.5,2.3,6.8,2.3c1,0,1.9,0,2.7-0.1c0.9-0.1,1.7-0.1,2.6-0.2
                c0.3-0.1,0.6-0.1,0.9,0.1c0.3,0.2,0.4,0.5,0.4,1v13.2c0,1.2-0.4,1.9-1.3,2.1c-2.1,0.7-4.3,1.2-6.4,1.6c-2.6,0.5-5.1,0.7-7.7,0.6
                c-7,0-12.5-1.8-16.4-5.5c-4-3.6-6-9.5-6-17.5V104h-9.5c-0.9,0-1.3-0.5-1.3-1.4V86.7c0-0.9,0.5-1.3,1.4-1.3h9.5
                c0.1-1.8,0.2-3.9,0.4-6.4c0.2-2.4,0.4-4.8,0.6-7.2c0.3-2.4,0.5-4.4,0.7-5.9c0.1-0.3,0.3-0.6,0.5-0.9c0.2-0.3,0.5-0.5,0.8-0.6
                l19.2-2.4c0.4-0.1,0.7-0.1,0.9,0c0.2,0.1,0.2,0.4,0.2,0.9c-0.2,2.5-0.4,5.8-0.5,10.1c-0.1,4.2-0.2,8.3-0.3,12.3h15
                c0.6,0,1,0.4,1,1.3V102.9z"/>
            <path d="M96.8,81.1c-3.7-1.5-7.7-2.1-11.8-2c-2.6,0-4.9,0-6.8,0.1c-2,0.1-3.4,0.1-4.1,0.2v33.3
                c1.4,0.1,2.7,0.2,3.9,0.2h5.3c3.9,0.1,7.8-0.5,11.5-1.6c3.2-0.9,6-2.8,8.2-5.3c2.1-2.5,3.1-5.9,3.1-10.3c0.1-3.1-0.7-6.2-2.3-8.9
                C102.1,84.2,99.7,82.2,96.8,81.1z"/>
        </g>
    </svg>
);

const sampler = (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" role="img" viewBox="0 0 240 234" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M165.2,130.4c-5.8,0-9.9,0.9-12.3,2.6c-2.3,1.6-3.7,4.3-3.6,7.1c0,1.7,0.5,3.3,1.4,4.7
                c1.1,1.6,2.7,2.8,4.5,3.5c2.5,1,5.2,1.5,8,1.4c1.8,0,3.7-0.1,5.5-0.4c1.4-0.3,3-0.7,4.5-1.1v-17.1c-1.3-0.2-2.5-0.4-3.7-0.5
                C168.3,130.5,166.9,130.4,165.2,130.4z"/>
            <path d="M197.5,0h-155C19,0,0,19,0,42.5v149C0,215,19,234,42.5,234h155c23.5,0,42.5-19,42.5-42.5v-149
                C240,19,221,0,197.5,0z M110.1,152.3c-3.6,4.9-8.5,8.7-14.1,11c-5.6,2.4-12.7,3.7-20.9,3.7c-5.5,0.1-11-0.5-16.3-1.5
                c-4.2-0.8-8.4-2.1-12.3-3.9c-0.9-0.4-1.3-1.3-1.3-2.7v-19.2c0-0.3,0.1-0.7,0.4-0.9c0.3-0.2,0.7-0.1,1,0.1c4.5,2.8,9.3,4.9,14.3,6.3
                c4.8,1.4,9.8,2.1,14.8,2.1c6.1,0,10.5-0.9,13.1-2.8c2.4-1.5,3.9-4.1,3.9-7c0-1.7-0.4-3.4-1.3-4.9c-1.2-1.7-2.7-3.2-4.5-4.3
                c-2.8-1.7-5.8-3.2-8.9-4.3l-8-3.4c-6.5-2.8-11.7-5.8-15.4-8.9c-3.4-2.7-6-6.2-7.6-10.2c-1.4-3.8-2.1-7.7-2.1-11.8
                c-0.2-11.6,6.6-22.3,17.2-27c5.7-2.7,12.8-4.1,21.3-4.1c4.8,0,9.6,0.3,14.4,1c3.7,0.4,7.3,1.5,10.7,3.1c0.7,0.4,1.2,1.2,1.1,2.1V83
                c0,0.3-0.2,0.6-0.5,0.8c-0.4,0.2-0.8-0.1-1.1-0.2c-0.6-0.3-1.2-0.6-1.8-0.9c-1.2-0.5-2.4-1-3.7-1.5c-1.2-0.4-2.5-0.8-3.8-1.2
                c-0.6-0.2-1.3-0.3-1.9-0.5c-4.4-1-8.9-1.5-13.4-1.4c-2.7,0-5.3,0.2-7.9,0.8c-1.8,0.4-3.6,1.1-5.2,2c-1.3,0.7-2.3,1.8-3,3.1
                c-0.6,1.2-1,2.5-1,3.8c0,1.6,0.5,3.3,1.4,4.6c1.3,1.7,3,3,4.8,4c3,1.7,6.1,3.3,9.3,4.7l6,2.3c7.1,2.9,12.6,6,16.6,9.3
                c3.6,2.8,6.5,6.5,8.4,10.6c1.6,3.9,2.4,8.1,2.4,12.3C115.3,141.6,113.5,147.4,110.1,152.3z M194.9,159.8c-4.8,1.8-9.1,3.3-12.9,4.3
                c-3.6,1-7.2,1.8-10.9,2.3c-3.7,0.4-7.5,0.7-11.3,0.6c-5.6,0.1-11.1-0.9-16.3-2.9c-4.7-1.8-8.8-4.9-11.8-8.9s-4.5-9-4.5-15.1
                c0-5.8,1.6-10.6,4.7-14.5c3.4-4,7.9-7.1,13-8.7c6.1-2,12.4-3,18.8-2.9h5.9c1.2,0,2.4,0,3.6,0.2v-1c-0.1-1-0.2-1.9-0.6-2.8
                c-0.4-1.3-1.2-2.5-2.2-3.5c-1.3-1.2-2.9-2.1-4.6-2.7c-2.6-0.8-5.3-1.1-8-1c-3.9,0-7.8,0.3-11.6,1.1c-3.4,0.7-6.7,1.7-9.8,3.1
                c-0.3,0.1-0.7,0.1-1,0c-0.3-0.1-0.5-0.5-0.5-0.8V90.4c-0.1-0.8,0.4-1.5,1.1-1.8c3.8-1.7,7.9-2.9,12-3.6c4.5-0.8,8.9-1.2,13.3-1.2
                c7.9,0,14.4,1.4,19.2,4.3c4.7,2.7,8.5,6.8,10.9,11.8c2.4,5.2,3.6,10.9,3.5,16.6v31.1c0,2,0,4,0.1,5.8c0.1,1.8,0.1,3.7,0.2,5.6
                C195.2,159.4,195.1,159.7,194.9,159.8z"/>
        </g>
    </svg>
);

const IconMap = {
    'question': <AiFillQuestionCircle />,
    'arrowup': <BsChevronBarUp />,
    'arrowdown': <BsChevronBarDown />,
    'cogwheel': <FaCog />,
    
    'email': <MdEmail />,
    'linkedin': <GrLinkedin />,
    'github': <FaGithub />,
    'artstation': <FaArtstation />,
    'steam': <FaSteam />,

    'javascript': <IoLogoJavascript />,
    'typescript': <SiTypescript />,
    'python': <FaPython />,
    'c': <SiC />,
    'c++': <SiCplusplus />,
    'html': <FaHtml5 />,
    'css': <FaCss3Alt />,

    'react': <FaReact />,
    'angular': <FaAngular />,
    'wpf': <FaWpforms />,
    'node.js': <FaNodeJs />,
    '.net': <SiDotnet />,
    'googlesignin': <MdScreenLockPortrait />,
    'restapi': <TbApi />,
    'entityframework': <FaDatabase />,
    'aws': <FaAws />,
    'postgresql': <BiLogoPostgresql />,
    'sqlite': <SiSqlite />,

    'source': <SiSourceengine />,
    'blender': <SiBlender />,
    'designer': designer,
    'painter': painter,
    'sampler': sampler
};

export default IconMap;